import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
export default (function (prevProps, nextProps) {
  var prevPages = prevProps.pages,
    prevSlides = prevProps.slides;
  var nextPages = nextProps.pages,
    nextSlides = nextProps.slides;
  var arePagesObjectDifferent = Object.keys(prevPages).length !== Object.keys(nextPages).length || Object.keys(prevPages).some(function (pageId) {
    return prevPages[pageId].empty !== nextPages[pageId].empty;
  });
  var areSlidesObjectDifferent = prevSlides.length !== nextSlides.length || prevSlides.some(function (slideItems, slideIndex) {
    var _nextSlides$slideInde;
    var items = slideItems.map(function (el) {
      return "".concat(el.id, "_").concat(el.content_type);
    });
    var prevItems = nextSlides === null || nextSlides === void 0 || (_nextSlides$slideInde = nextSlides[slideIndex]) === null || _nextSlides$slideInde === void 0 ? void 0 : _nextSlides$slideInde.map(function (el) {
      return "".concat(el.id, "_").concat(el.content_type);
    });
    return items && items.length !== (prevItems === null || prevItems === void 0 ? void 0 : prevItems.length) || (items === null || items === void 0 ? void 0 : items[0]) !== (prevItems === null || prevItems === void 0 ? void 0 : prevItems[0]);
  });
  var propsAreEqual = !arePagesObjectDifferent && !areSlidesObjectDifferent && prevProps.initialSlide === nextProps.initialSlide && prevProps.activeSlide === nextProps.activeSlide && prevProps.height === nextProps.height;
  return propsAreEqual;
});